import { Box, Stack } from '@mui/material';
import React from 'react';

import { MobileBody, MobileBody2, MobileSubtitle } from '../Typography';
import { getBackgroundColor } from '../utils';

export type IconTitleCardIconVariant = 'outline' | 'filled';

export interface IconTitleCardProps {
  icon?: React.ReactNode;
  adornmentText?: string | number;
  title: string;
  description?: string;
  iconVariant?: IconTitleCardIconVariant;
  IconColor?: string;
  sx?: object;
}

const ICON_SIZE = 36;

const IconTitleCard: React.FC<IconTitleCardProps> = ({
  icon,
  adornmentText,
  title,
  description,
  iconVariant = 'filled',
  IconColor = 'primary',
  sx,
}) => {
  const hasDescription = description != null && description !== '';
  const showIcon = adornmentText == null && icon != null;
  const showAdornment = adornmentText != null;
  const alignCenter =
    iconVariant === 'outline' ||
    (!hasDescription && (showIcon || showAdornment));
  const iconColor = getBackgroundColor(IconColor, 1);
  const iconBackgroundColor =
    iconVariant === 'filled' ? getBackgroundColor(IconColor, 0.2) : undefined;

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        px: 1.5,
        py: 1.25,
        ...sx,
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems={alignCenter ? 'center' : 'flex-start'}
      >
        {showAdornment && (
          <Box
            sx={{
              width: ICON_SIZE,
              height: ICON_SIZE,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              color: iconColor,
              backgroundColor: iconBackgroundColor,
              fontSize: '0.875rem',
              fontWeight: 600,
            }}
          >
            <MobileBody2
              component="span"
              sx={{ fontSize: '0.875rem', fontWeight: 600 }}
            >
              {String(adornmentText)}
            </MobileBody2>
          </Box>
        )}
        {showIcon && (
          <Box
            sx={{
              ...(iconVariant === 'outline'
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    color: iconColor,
                  }
                : {
                    width: ICON_SIZE,
                    height: ICON_SIZE,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    color: iconColor,
                    backgroundColor: iconBackgroundColor,
                  }),
            }}
          >
            {icon}
          </Box>
        )}
        <Box component="span" sx={{ minWidth: 0, display: 'block' }}>
          <Stack spacing={0.25} sx={{ minWidth: 0 }}>
            <MobileSubtitle
              component="span"
              sx={{ color: 'text.primary', fontSize: '1rem' }}
            >
              {title}
            </MobileSubtitle>
            {hasDescription && (
              <MobileBody
                component="span"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.75rem',
                  fontWeight: 400,
                }}
              >
                {description}
              </MobileBody>
            )}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default IconTitleCard;
